require([
	'jquery',
	'root/Base/Js/MbiMediaQuery',
	'flickity'
], function(
	$,
	mbiMq,
	flickity
	) {

	'use strict';


	if ($('.section-hero-animation').length) {


		var $grids = $('.section-grid-selection'),
			$audience = $('.section-grid-selection.is_active'),
			audience = $('html').attr('data-audience'),
			heroSlider,
			$images = $('.signpost-image, .audience-image');

		function textNavigation(newAudience) {
			$('.js_change-audience').removeClass('is_active');
			$('.js_change-audience').filter('[data-audience=' + newAudience + ']').addClass('is_active');
		}


		function interruptAnimation() {
			$('.audience-image').attr('animation', false);
			$('.signpost-image').attr('animation', false);
			$('.animation-navigation__item').attr('animation', false);
		}

		function startAnimation(audience) {
			setTimeout(function(){
				$("[data-audience]").attr('animation', false);
				$("[data-audience='" + audience + "']").attr('animation', true);
			}, 10);
		}


		function setActiveGrid($gridNavigationItem) {

			var audience = $gridNavigationItem.attr('data-audience');
			$images.attr('data-active', false);
			$images.filter('[data-audience=' + audience + ']').attr('data-active', true);

			if (!$gridNavigationItem.hasClass('is_active')) {
				$('.js_change-audience').removeClass('is_active');
				$('.js_change-audience').each(function(){
					if ($(this).attr('data-audience') === $gridNavigationItem.attr('data-audience')) {
						$(this).addClass('is_active');
					}
				});

				$grids.removeClass('is_active');;
				$grids.each(function(){
					if ($(this).attr('data-audience') === $gridNavigationItem.attr('data-audience')) {
						$(this).addClass('is_active');
					}
				});
			}
		}


		function initFlickity(container, slide) {
			return new flickity(container, {
				cellSelector: slide,
				wrapAround: true,
				prevNextButtons: false,
				watchCSS: false,
				autoPlay: false
			});
		}


		function initHeroSlider() {
			if ('lap-' in mbiMq.mqArea && !heroSlider) {
				heroSlider = initFlickity('.animation-navigation', '.animation-navigation__item');
				heroSlider.on('select', function(){
					setActiveGrid($(heroSlider.selectedElement));
				});
			} else if ('pad+' in mbiMq.mqArea && heroSlider) {
				heroSlider.destroy();
				heroSlider.off('select');
				heroSlider = false;
			}	
		}


		$('.audience-path, .signpost-path, .animation-navigation__item').mouseenter(function(){
			startAnimation($(this).attr('data-audience'));
		});

		$('.section-hero-animation').mouseleave(function(){
			interruptAnimation();
		});

		$('.audience-path, .signpost-path, .js_change-audience, .animation-navigation__item').click(function(e){
			e.preventDefault();
			e.stopPropagation();

			if ('pad+' in mbiMq.mqArea) {
				setActiveGrid($(this));
			}
		});


		$(document).on('breakpoint', function(){
			initHeroSlider();
		});


		initHeroSlider();
		textNavigation(audience);
		$images.filter('[data-audience=' + audience + ']').attr('data-active', true);


	}
});
define("root/Assets/Templates/Html/HeroAnimation/Js/HeroAnimation", function(){});

